export const LIST1 = [
  { title: '初级会计实务知识点', linkUrl: 'https://m.zhuokao360.com/know/list/1' },
  { title: '经济法基础知识点', linkUrl: 'https://m.zhuokao360.com/know/list/2' },
];

export const LIST2 = [
  { title: '中级会计实务知识点', linkUrl: 'https://m.zhuokao360.com/know/list/3' },
  { title: '经济法知识点', linkUrl: 'https://m.zhuokao360.com/know/list/4' },
  { title: '财务管理知识点', linkUrl: 'https://m.zhuokao360.com/know/list/5' },
];
